import React from 'react';
import { Tab } from 'rbx';

const Tabs = ({ children }) => <Tab.Group size="medium">{children}</Tab.Group>;

export default Tabs;
